var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgAd = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M20 15a4 4 0 0 1 4-4h48a4 4 0 0 1 4 4v66a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4V15Z"
  }), React.createElement("path", {
    fill: borderColor,
    fillRule: "evenodd",
    d: "M72 12.5H24a2.5 2.5 0 0 0-2.5 2.5v66a2.5 2.5 0 0 0 2.5 2.5h48a2.5 2.5 0 0 0 2.5-2.5V15a2.5 2.5 0 0 0-2.5-2.5ZM24 11a4 4 0 0 0-4 4v66a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V15a4 4 0 0 0-4-4H24Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M57 63.95a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM29 57.45a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75ZM29 50.95a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5h-22.5a.75.75 0 0 1-.75-.75ZM57 50.95a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM41 57.45a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5h-22.5a.75.75 0 0 1-.75-.75ZM29 63.95a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5h-22.5a.75.75 0 0 1-.75-.75Z"
  }), React.createElement("path", {
    fill: color,
    d: "M29 73.45a2.75 2.75 0 0 1 2.75-2.75h14.5a2.75 2.75 0 1 1 0 5.5h-14.5A2.75 2.75 0 0 1 29 73.45Z"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M29.25 35.46a7.05 7.05 0 1 1 14.1 0 7.05 7.05 0 0 1-14.1 0Zm7.05-5.55a5.55 5.55 0 1 0 0 11.1 5.55 5.55 0 0 0 0-11.1ZM56.753 26.477a.75.75 0 0 1-.098 1.057L46.43 36.027a.75.75 0 1 1-.959-1.154l10.227-8.493a.75.75 0 0 1 1.056.098Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M52.56 35.462a7.05 7.05 0 1 1 14.1 0 7.05 7.05 0 0 1-14.1 0Zm7.05-5.55a5.55 5.55 0 1 0 0 11.1 5.55 5.55 0 0 0 0-11.1Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M57.256 23.964c.152 2.78.364 6.651 3.001 11.115a.75.75 0 0 1-1.291.763c-2.828-4.786-3.055-8.975-3.207-11.78l-.03-.555c-.042-.702-.088-1.263-.178-1.711-.09-.452-.21-.702-.337-.844-.19-.213-.672-.457-2.351-.01a.75.75 0 1 1-.387-1.448c1.687-.45 3.027-.473 3.858.46.384.432.575.987.688 1.546.113.563.163 1.22.204 1.919l.03.545Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M43.255 24.497a.75.75 0 0 1 .609-.313h12.6a.75.75 0 0 1 0 1.5H44.25l-6.5 9.052 8.033.126a.75.75 0 0 1-.024 1.5l-9.466-.15a.75.75 0 0 1-.598-1.187l7.56-10.528Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M43.155 21.483a.75.75 0 0 1 .882.589l2.648 13.23a.75.75 0 0 1-1.47.295l-2.649-13.231a.75.75 0 0 1 .589-.883Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M40.7 22.174a.75.75 0 0 1 .75-.75h4.04a.75.75 0 0 1 0 1.5h-4.04a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
};
export default SvgAd;